import { useState } from 'react'
import ReportFixedTable from 'features/report/table/ReportFixedTable'
import ReportScrollableTable from 'features/report/table/ReportScrollableTable'
import classNames from 'classnames'
import MultiTable from 'components/table/MultiTable'
import {
  ReportColumnAdGroupName,
  ReportColumnBizChannelName,
  ReportColumnCampaignName,
  ReportColumnCampaignType,
  ReportColumnEndDate,
  ReportColumnKeyword,
  ReportColumnStartDate,
} from 'features/report/common/ReportColumns'

const ReportKeywordTable = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  return (
    <div className={classNames('table_wrap', { scroll_ing: isScrolled })}>
      <MultiTable.Container>
        <ReportFixedTable />
        <ReportScrollableTable
          caption="맞춤보고서 키워드 테이블"
          onIsScrolledChange={setIsScrolled}
          baseColumns={[
            ReportColumnCampaignType,
            ReportColumnCampaignName,
            ReportColumnAdGroupName,
            ReportColumnBizChannelName,
            ReportColumnKeyword,
            ReportColumnStartDate,
            ReportColumnEndDate,
          ]}
        />
      </MultiTable.Container>
    </div>
  )
}

export default ReportKeywordTable
